import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { getMaintenanceConfigurations } from '../../../services/maintenanceService';
import {
  maintenaceConfigurationsHasAnyFilterState,
  maintenanceConfigurationsFiltersState,
  maintenanceConfigurationsReloadListState,
} from '../../../storage/maintenaceConfigurations';

function useMaintenanceConfigurations() {
  const [filters, setFilters] = useRecoilState(maintenanceConfigurationsFiltersState);
  const [reload, setReload] = useRecoilState(maintenanceConfigurationsReloadListState);
  const resetAllFilters = useResetRecoilState(maintenanceConfigurationsFiltersState);
  const hasActiveFilters = useRecoilValue(maintenaceConfigurationsHasAnyFilterState);

  const resetFilters = () => {
    setFilters((prev) => ({
      ...prev,
      triggerType: undefined,
      maintenanceTypeId: undefined,
      ownedByMe: false,
    }));
  };

  const onReload = () => {
    setReload((prev) => !prev);
  };

  const onChangeFilter = (filterName: keyof typeof filters, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const loadFleetMaintenanceConfigurations = async () => {
    const { configurations, error, total } = await getMaintenanceConfigurations({
      page: filters.page,
      triggerType: filters.triggerType,
      maintenanceTypeId: filters.maintenanceTypeId,
      search: filters.search,
    });
    return {
      configurations,
      error,
      total,
    };
  };

  return {
    hasActiveFilters,
    loadFleetMaintenanceConfigurations,
    onReload,
    reload,
    resetAllFilters,
    resetFilters,
    page: filters.page,
    onChangePage: (page: number) => {
      onChangeFilter('page', page);
    },
    search: filters.search,
    onChangeSearch: (search: string) => {
      onChangeFilter('search', search);
    },
    filters: {
      triggerType: filters.triggerType,
      maintenanceTypeId: filters.maintenanceTypeId,
    },
    onChangeFilter: (filterName: 'triggerType' | 'maintenanceTypeId', value: any) => {
      onChangeFilter(filterName, value);
    },
  };
}

export default useMaintenanceConfigurations;
